import { PerformanceEventProperties } from '@ms/yammer-telemetry/dist/performance';

import { AnalyticsEvent, AnalyticsV2Event, AnalyticsV2EventProperties } from './analyticsEvent.types';
import { ErrorEvent } from './errorEvent.types';
import { InfoEvent } from './infoEvent.types';

export * from './publisher.types';
export * from './infoEvent.types';
export * from './errorEvent.types';
export * from './analyticsEvent.types';

export interface TelemetryEvents {
  readonly errorEvents: ErrorEvent[];
  readonly analyticsEvents: AnalyticsEvent[];
  readonly performanceEvents: PerformanceEvent[];
  readonly infoEvents: InfoEvent[];
}

export interface BaseTelemetryEvent {
  readonly type: TelemetryEventType;
  readonly name: string;
  readonly occurredAt: string;
  readonly skipAuthentication?: boolean;
}

export enum TelemetryEventType {
  Analytics = 'Analytics',
  AnalyticsV2 = 'AnalyticsV2',
  Error = 'Error',
  Info = 'Info',
  Performance = 'Performance',
}

export type LogEvent = ErrorEvent | InfoEvent | PerformanceEvent;
export type TelemetryEvent = AnalyticsEvent | AnalyticsV2Event | LogEvent;

export type TelemetryPropertyValueType =
  | string
  | number
  | boolean
  | undefined
  | null
  | string[]
  | AnalyticsV2EventProperties['timestamp']
  | readonly PerformanceServerTiming[];
export type TelemetryProperties = Record<string, TelemetryPropertyValueType>;

export interface PropertyCheckEventProperties {
  readonly droppedKeys: string;
}

export enum EventCardLocation {
  Discovery = 'discovery',
  Group = 'group',
}

export interface PerformanceEvent extends BaseTelemetryEvent {
  readonly type: TelemetryEventType.Performance;
  readonly duration?: number;
  readonly startTime?: number;
  readonly properties: Record<string | keyof PerformanceEventProperties, TelemetryPropertyValueType>;
}

export enum EventReferrer {
  GlammerAttendeeLink = 'GlammerAttendeeLink',
  GroupBanner = 'GroupFeedBanner',
  DiscoveryFeedBanner = 'DiscoveryFeedBanner',
  Calendar = 'Calendar',
  FeedSelectorDropdown = 'FeedSelectorDropdown',
  Create = 'Create',
  Notification = 'Notification',
  Unknown = 'Unknown',
}

export interface LogEvents {
  readonly errorEvents: ErrorEvent[];
  readonly performanceEvents: PerformanceEvent[];
  readonly infoEvents: InfoEvent[];
}

export enum ImageSurface {
  Fullscreen = 'fullscreen',
  Thumbnail = 'thumbnail',
  MomentThumbnail = 'momentThumbnail',
}

export enum ImageOrigin {
  Azure = 'azure',
  Avatar = 'avatar',
  Web = 'web',
  SharePoint = 'sharepoint',
}

export enum ImageType {
  Standard = 'standard',
  Blob = 'blob',
}

export enum MomentCreationType {
  Record = 'Record',
  Upload = 'Upload',
}
